import { links } from 'common/helpers/links'


const routeParams = {}

const iterate = (links, pagePath = '', analyticParams = {}): void => {
  Object.keys(links).forEach((key) => {
    const value = links[key]

    if ('root' in value) {
      const { root, ...rest } = value
      const { path, analytics = {} } = root

      const fullPath = `${pagePath}/${path}`

      routeParams[fullPath] = { ...analyticParams, ...analytics }

      iterate(rest, fullPath, analytics)
    }
    else {
      const { path, analytics } = value
      const fullPath = path[0] === '/' ? path : `${pagePath}/${path}`

      routeParams[fullPath] = { ...analyticParams, ...analytics }
    }
  })
}

const { fromBackend, ...localLinks } = links

iterate(localLinks)

if (fromBackend) {
  iterate(fromBackend)
}

if (typeof window !== 'undefined') {
  if (!window.__debug__) {
    window.__debug__ = {}
  }

  window.__debug__.snowplowRouteParams = routeParams
}


export default routeParams
